"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VanishingPen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VanishingPen_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.113 4.488 6.66 11.942a3.275 3.275 0 0 1-1.296.803l-2.469.799c-.447.145-1.047.113-1.488-.328-.441-.441-.474-1.042-.329-1.489l.8-2.47c.157-.486.44-.932.802-1.294L10.134.508c.251-.251.594-.443.983-.495.397-.052.857.047 1.203.393l1.895 1.895c.347.347.446.807.393 1.203-.051.39-.244.732-.495.984Zm-3.272-3.273L9.184 2.872l2.565 2.565 1.657-1.656a.725.725 0 0 0 .211-.408.426.426 0 0 0-.109-.365l-1.895-1.895a.426.426 0 0 0-.365-.108.724.724 0 0 0-.407.21ZM3.386 8.67l5.091-5.09 2.565 2.564-5.09 5.09c-.26.26-.571.454-.897.56l-2.469.798c-.184.06-.361.028-.473-.084-.112-.112-.144-.29-.084-.473l.799-2.47c.105-.325.3-.636.558-.895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.066 13.938a.5.5 0 0 0-.704-.064l-.137.115a4.079 4.079 0 0 1-5.223 0l-.069-.058a.5.5 0 0 0-.64.769l.069.057a5.079 5.079 0 0 0 6.503 0l.137-.114a.5.5 0 0 0 .064-.705ZM14.113 13.508a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM9.613 13.508a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM12.113 12.508a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM15.113 15.508a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VanishingPen_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VanishingPen;
exports["default"] = _default;